import { create } from 'zustand';

export const useSinisterStore = create((set, get) => ({
  sinisterType: '',
  setSinisterType: (value) => set({ sinisterType: value }),
}));
